import {
  periods,
  gameModes,
  difficultyModes,
} from './globalState';

function getTotal({ record }) {
  return record?.total ?? 0;
}

function buildGameRecord({ periodStatistics }) {
  const win = getTotal({ record: periodStatistics.win });
  const lose = getTotal({ record: periodStatistics.lose });
  const draw = getTotal({ record: periodStatistics.draw });
  const numberOfDuelsForWinRate = win + lose;
  const winRate = numberOfDuelsForWinRate > 0 ? win / numberOfDuelsForWinRate : 0;

  return {
    win,
    lose,
    draw,
    winRate,
  };
}

function buildPlayerStatsRecords({ statistics }) {
  return periods.map(period => ({
    period,
    gameModes: gameModes.map(gameMode => ({
      gameMode,
      difficultyModes: difficultyModes.map(difficultyMode => ({
        difficultyMode,
        record: buildGameRecord({
          periodStatistics: statistics?.[difficultyMode]?.[gameMode]?.[period] ?? {},
        }),
      })),
    })),
  }));
}

function getCollectibleWordFace({ collectibleWordsMaster, word, language }) {
  return collectibleWordsMaster[word].faces[language][0];
}

function getCollectibleWordImageUrl({ collectibleWordsMaster, word, collectibleWordImageHostPath }) {
  const filename = collectibleWordsMaster[word].image.filename;
  return `https://${collectibleWordImageHostPath}/${encodeURIComponent(filename)}`;
}

function getCollectibleWordTotalCount({ count }) {
  return count.liveText + count.field + count.straightManText;
}

function buildCollectibleWordRecords({ collection, collectibleWordsMaster, language, collectibleWordImageHostPath }) {
  const localeByLanguage = {
    japanese: 'ja',
    english: 'en',
  };
  const locale = localeByLanguage[language] ?? language;

  return (collection?.collectibleWords ?? [])
  .map(collectibleWord => ({
    word: collectibleWord.word,
    face: getCollectibleWordFace({
      collectibleWordsMaster,
      word: collectibleWord.word,
      language,
    }),
    imageUrl: getCollectibleWordImageUrl({
      collectibleWordsMaster,
      word: collectibleWord.word,
      collectibleWordImageHostPath,
    }),
    count: getCollectibleWordTotalCount({
      count: collectibleWord.count,
    }),
  }))
  .sort((a, b) => {
    if (b.count !== a.count) {
      return b.count - a.count;
    }

    return a.face.localeCompare(b.face, locale);
  });
}

function formatWinRate({ winRate }) {
  return `${Math.round(winRate * 10000) / 100}%`;
}

export {
  buildPlayerStatsRecords,
  buildCollectibleWordRecords,
  formatWinRate,
};
